import React, { useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { ToastProvider } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import metadata from './RevenueComponent.metadata.json5';
import styles from '../../../pages/Accountant/AccountantPage.module.scss';
import messages from './RevenueComponent.messages';
import ServiceComponent from '../Subcomponents/Service/ServiceComponent';

function RevenueComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('RevenueComponent');
    const translator = useTranslator();
    const modelVM = _.get(submissionVM, pathUpdated);        

    modelVM.value.isValidationReq = true

    const initializeTotalFields = () => {
        const totPerAll2Value = _.get(modelVM, 'totPerAll2.value') !== undefined
            ? _.get(modelVM, 'totPerAll2.value') : 0;

        _.set(modelVM, 'totPerAll2.value', totPerAll2Value);
    }

    useEffect(() => {
        initializeTotalFields()
    }, [])

    const getTotPerAll2 = () => {
        let sum = 0;

        modelVM.value.services.forEach((service) => {
            if (!_.isUndefined(service.revCalByPer2)) {
                sum += service.revCalByPer2
            }
        })

        const existingSum = _.get(submissionVM.value, `${pathUpdated}.totPerAll2`)

        if (sum !== 0 && sum !== existingSum) {
            const fullPath = `${pathUpdated}.totPerAll2`;

            _.set(submissionVM, `${fullPath}`, sum);

            updateWizardData(submissionVM);
        }

        return sum

    };

    const getTotPerAll4 = () => {
        let subSum = 0;

        if (modelVM.value.subContractedServices.length > 0) {
            modelVM.value.subContractedServices.forEach((subContractedService) => {
                if (!_.isUndefined(subContractedService.revCalByPer2)) {
                    subSum += subContractedService.revCalByPer2
                }
            })

            const existingSubSum = _.get(submissionVM.value, `${pathUpdated}.totPerAll4`)

            if (subSum !== 0 && subSum !== existingSubSum) {
                const fullSubPath = `${pathUpdated}.totPerAll4`;

                _.set(submissionVM, `${fullSubPath}`, subSum);
                updateWizardData(submissionVM);
            }
        }

        return subSum
    };

    useEffect(() => {
        const isAnyWorkSubContacted = _.get(modelVM.value, 'isAnyWorSub27')
        if(isAnyWorkSubContacted === false) {
            _.set(submissionVM.value, `${pathUpdated}.subContractedServices`, [])
            updateWizardData(submissionVM)
        }
    }, [modelVM.value.isAnyWorSub27])

    const getInsuPro = (values, isSubContractService) => {

        if(_.isUndefined(values) || values.length === 0 || _.isUndefined(values.find((value) => !_.isEmpty(value)))) {
            if(isSubContractService) {
                return _.get(modelVM.value, 'insProBus1')
            } 

            return _.get(modelVM.value, 'insProBus22')
        }

        let result = ''

        values.forEach((value) => {
                if (!_.isUndefined(value.proSer1)) {
                    const resultVal = translator({
                        id: `typekey.EY_AccProSer1.${value.proSer1}`,
                        defaultMessage: value.proSer1,
                    })
            
                    result = result.concat(resultVal).concat(', ')
                }
            })
        
        const res = result.trim().substr(0, result.length - 2)
        
        _.set(modelVM.value, 'insProBus22', res)

        const insProBus1Val = _.get(modelVM.value, 'insProBus1');
        
        if (insProBus1Val !== res && isSubContractService) {
            _.set(modelVM.value, 'insProBus1', res)
            const fullSubPath = `${pathUpdated}.insProBus1`;
            _.set(submissionVM, `${fullSubPath}.insProBus1`, res);
            updateWizardData(submissionVM);
        }

        return res
    };


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        serviceComponent: {
            data: modelVM.services,
            updateWizardData,
            submissionVM,
            CompanyContractDetailsPath: `${pathUpdated}.services`,
            isSubContractService: false
        },
        subContServiceComponent: {
            data: modelVM.subContractedServices,
            updateWizardData,
            submissionVM,
            CompanyContractDetailsPath: `${pathUpdated}.subContractedServices`,
            isSubContractService: true
        },
        subcontractContainer: {
            visible: _.get(submissionVM.value, `${pathUpdated}.isAnyWorSub27`) === true
        },
        totPerAll2: { 
            value: getTotPerAll2()
        },
        totPerAll4: {
            value: getTotPerAll4()
        },
        descOfOthServ: {
            visible: !_.isUndefined(_.get(submissionVM.value, `${pathUpdated}.isOtherInService`)) && _.get(submissionVM.value, `${pathUpdated}.isOtherInService`)
        },
        descOfOthServ1: {
            visible: !_.isUndefined(_.get(submissionVM.value, `${pathUpdated}.otherSubConsExists`)) && _.get(submissionVM.value, `${pathUpdated}.otherSubConsExists`)
        },
        insProBus1: {
            value: getInsuPro(_.get(submissionVM.value, `${pathUpdated}.subContractedServices`), true)
        },
        allFeeAssOutOfCan43: {
            visible: !_.isUndefined(modelVM.value.isTheAppOrAnyAdvInv41) && modelVM.value.isTheAppOrAnyAdvInv41
        },
        insProBus22: {
            value: getInsuPro(_.get(submissionVM.value, `${pathUpdated}.services`), false)
        },
        annIncForTheLasFisYea30: {
            visible: _.get(submissionVM.value, `${pathUpdated}.isAnyWorSub27`) === true
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            serviceComponent: ServiceComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            if(changedPath === 'totPerAll2') {
                ToastProvider.toast({
                    type: 'error',
                    message: translator(messages.totalPercAllocatedErrorMessage),
                    autoClose: true
                });
            }

            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, translator, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

RevenueComponent.propTypes = wizardProps;
export default withRouter(RevenueComponent);